const kiddata=[
    {
        id:1,
        category:"Tshirst",
        img:"https://cms.cloudinary.vpsvc.com/image/upload/c_scale,dpr_auto,f_auto,q_auto:best,t_productPageHeroGalleryTransformation_v2,w_auto/India%20LOB/Clothing%20and%20Bags/Basic%20Cotton%20T-Shirts%20-%20Kids/IN_Basic-Cotton-T-Shirts-Kids_Hero-image_01",
        price:80
       
    },
    
    
    {
        id:2,
        category:"Pant",
        img:"https://m.media-amazon.com/images/I/51jInkHsGRL._AC_UY1100_.jpg",
       price:70.85
    },
    {
        id:3,
        category:"Frock",
       img:"https://media.istockphoto.com/id/956002684/photo/little-cute-girl-in-dress.jpg?s=612x612&w=0&k=20&c=qf832JQH4y4H6ySz5AeOFTl_X9sd2GqK1RtZifmrpZU=",
       price:99.89
    },
    {
        id:4,
        category:"Tshirt",
       img:"https://m.media-amazon.com/images/I/61fHHyKmdWL._AC_UY1100_.jpg",
       price:70.41
    },
    {
        id:5,
        category:"Frock",
       img:"https://5.imimg.com/data5/WU/MC/TD/ANDROID-22778057/product-jpeg-500x500.jpg",
       price:"60.99"
    },
    {
        id:6,
        category:"Pant",
       img:"https://m.media-amazon.com/images/I/51hrWH-YvOL._AC_UY1100_.jpg",
       price:90.89
    },
    {
    id:7,
    category:"Frock",
    img:"https://m.media-amazon.com/images/I/51zdS6XtWJL._AC_UY1100_.jpg",
    price:70.99
    },
    {
        id:8,
        category:"Tshirt",
       img:"https://cms.cloudinary.vpsvc.com/image/upload/c_scale,dpr_auto,f_auto,q_auto:best,t_productPageHeroGalleryTransformation_v2,w_auto/India%20LOB/Clothing%20and%20Bags/Kid's%20Cotton%20T-Shirts/IN_Kid_s-Cotton-T-Shirts-Grey",
       price:80.77
    }
    ]
    export default kiddata